import {CurrencyRangeConstraintDataDto} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";
import {ConstraintPluginProps} from "../ConstraintDataPlugin";
import {Grid} from "@mui/material";
import {t} from "../../../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import React from "react";
import {NumericField} from "../../../../../../components/fields/textfield/NumericField";


export function CurrencyRangeConstraintPluginForm(props: Readonly<ConstraintPluginProps<CurrencyRangeConstraintDataDto>>) {
    const {data, onChange, errors} = props;
    function updateMin(numValue: number | undefined) {
            onChange({
                ...data,
                min: numValue
            });
    }

    function updateMax(numValue: number | undefined) {
        onChange({
            ...data,
            max: numValue
        });
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <NumericField
                    label={t(DataTypeTranslationKey.MIN_VALUE)}
                    value={data.min}
                    onChange={updateMin}
                    precision={2}
                    errorMessage={errors?.min ? t(errors.min) : undefined}
                    clearable={true}
                    allowedInputRegex={/^-?\d+([.,]\d+)?$/}
                />
            </Grid>
            <Grid item xs={6}>
                <NumericField
                    label={t(DataTypeTranslationKey.MAX_VALUE)}
                    value={data.max}
                    onChange={updateMax}
                    precision={2}
                    errorMessage={errors?.max ? t(errors.max) : undefined}
                    clearable={true}
                    allowedInputRegex={/^-?\d+([.,]\d+)?$/}
                />
            </Grid>
        </Grid>
    );

}
